import Logo from 'components/logo/Logo'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import I18n from 'resources/i18n/I18n'
import GroupApi from 'services/groupApi'
import Title from '../../typo/Title'
import ItemList from '../ItemList'
import '../configuration.scss'

const EstateEdition = () => {
  const user = useSelector((state) => state.userReducer.user)
  const [group, setGroup] = useState(null)
  const location = useLocation()

  useEffect(() => {
    const groupId = new URLSearchParams(location.search).get('groupId')
    if (groupId) {
      GroupApi.getGroupByCode(groupId).then(setGroup)
    }
  }, [])

  return (
    <div className="container-fluid">
      <div className="row justify-content-center">
        <Logo />
      </div>
      <div className="container">
        <div className="row">
          <Title text={`${I18n.t('ConfigurationGroup')}${group && user.roles.includes('ORFI-ADMIN') ? ` : ${group.name || 'Nom inconnu'}` : ''}`} />
        </div>
        <div className="row">
          <ItemList title={I18n.t('EstateLabelConfiguration')} path={`/organismes/label${group ? `?groupId=${group.code}` : ''}`} />
          <ItemList title={I18n.t('EstateConfiguration')} path={`/organismes/patrimoine${group ? `?groupId=${group.code}` : ''}`} />
          <ItemList title={I18n.t('EstateAgencyConfiguration')} path={`/organismes/utilisateurs${group ? `?groupId=${group.code}` : ''}`} />
        </div>
      </div>
    </div>
  )
}

export default EstateEdition
